import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../../Services/Auth.service';
import { Router } from '@angular/router';
import { EmbryoService } from '../../Services/Embryo.service';

@Component({
  selector: 'embryo-HeaderUserMembership',
  templateUrl: './HeaderUserMembership.component.html',
  styleUrls: ['./HeaderUserMembership.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderUserMembershipComponent implements OnInit {

   constructor( public router:Router) { 
   }

   ngOnInit() {
   }

}
